/**
 * Vorbelegung von Schritt 1 aus dem KI-Chat.
 *
 * Der Chat startet den Wizard per Navigation und gibt mit, was er schon weiß (Kampagnenname,
 * Konto, Stellenanzeige). Die Werte reisen im Router-State, nicht in der URL – keine
 * personenbezogenen Daten in Adresszeile oder Verlauf. Gefüllt wird nur, was im Zustand noch
 * leer ist.
 */

import { WizardState } from './campaign-wizard.types';

export interface WizardPrefill {
  name?: string;
  accountId?: string;
  briefing?: string;
}

export const WIZARD_PREFILL_STATE_KEY = 'wizardPrefill';

const MAX_NAME = 100;
const MAX_BRIEFING = 20000;

const clean = (value: unknown, max: number): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const text = value.trim();
  return text ? text.slice(0, max) : undefined;
};

/** Übernimmt aus beliebigen Dialog-/State-Props nur die bekannten Felder (sonst `null`). */
export const toWizardPrefill = (props: unknown): WizardPrefill | null => {
  if (!props || typeof props !== 'object') return null;
  const p = props as Record<string, unknown>;
  const prefill: WizardPrefill = {
    name: clean(p.name, MAX_NAME),
    accountId: clean(p.accountId, 100),
    briefing: clean(p.briefing ?? p.jobOffer, MAX_BRIEFING),
  };
  return prefill.name || prefill.accountId || prefill.briefing ? prefill : null;
};

/** Liest die Vorbelegung aus dem Router-State der Navigation. */
export const readWizardPrefill = (routerState: unknown): WizardPrefill | null => {
  if (!routerState || typeof routerState !== 'object') return null;
  return toWizardPrefill((routerState as Record<string, unknown>)[WIZARD_PREFILL_STATE_KEY]);
};

/** Füllt nur leere Felder des Zustands. */
export const applyWizardPrefill = (state: WizardState, prefill: WizardPrefill | null): WizardState => {
  if (!prefill) return state;
  return {
    ...state,
    name: state.name.trim() ? state.name : (prefill.name ?? state.name),
    accountId: state.accountId ? state.accountId : (prefill.accountId ?? state.accountId),
    briefing: state.briefing.trim() ? state.briefing : (prefill.briefing ?? state.briefing),
  };
};
